import { isArrayWithLength } from "../../utils/array-methods";
import { formatDateYMD } from "../../utils/convert-date";
import defaultValuesOld from "../scenarios/edu-scenarios";

const projects = defaultValuesOld().departments;

export const getCostOptimizationData = (deptId) => {
  const date = new Date();
  const _project =
    isArrayWithLength(projects) &&
    projects.find((project) => project.ID === deptId);
  return {
    AbandonedResources: 64,
    LastRun: formatDateYMD(date),
    NeedsOptimization: 0,
    OverProvisioned: 0,
    PotentialCostSavings: _project ? _project.PotentialSavings : 1425,
    UnderProvisioned: 0,
  };
};
